import React from 'react';
import { Formik, Form } from 'formik';
import { Button, Input, Card, SageTokens, SageClassnames, Frame } from '@kajabi/sage-react';
import useSubmitPromptSetResult from 'common/components/CopyMagic/hooks/useSubmitPromptSetResult';
import { useUiResourceContext } from 'common/components/CopyMagic/contexts';
import { promptSchema } from 'common/components/CopyMagic/shared/validationSchema';

const PromptForm = () => {
  const { loading } = useUiResourceContext();
  const { initialValues, submitPrompt } = useSubmitPromptSetResult();

  return (
    <Formik
      initialValues={initialValues}
      onSubmit={submitPrompt}
      validationSchema={promptSchema}
      validateOnMount
    >
      {({ isValid, values, touched, errors, handleChange, handleBlur }) => (
        <Form>
          <Frame
            border={Frame.BORDERS.DEFAULT}
            borderRadius={Frame.BORDER_RADII.SM}
            background={SageTokens.COLOR_PALETTE.GREY_100}
            padding={Frame.PADDINGS.SM}
            gap={Frame.GAPS.NONE}
            width={Frame.WIDTHS.FILL}
            align={Frame.ALIGNMENTS.SPREAD_STRETCH}
          >
            <div>
              <h2
                className={`${SageClassnames.TYPE.BODY_SEMI} ${SageClassnames.SPACERS.XS_BOTTOM}`}
              >
                Course topic
              </h2>
              <Card.Row
                gridTemplate={SageTokens.GRID_TEMPLATES.TE}
                gap={SageTokens.GRID_GAP_OPTIONS.XS}
                verticalAlign={Card.Row.ALIGNMENT_OPTIONS.START}
              >
                <Input
                  id="topic"
                  label="Course topic"
                  hideLabel
                  placeholder="For example, Knitting for Beginners"
                  value={values.topic}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  hasError={touched.topic && !!errors.topic}
                  message={touched.topic && errors.topic}
                />
                <Button type="submit" disabled={!isValid || loading}>
                  Generate
                </Button>
              </Card.Row>
            </div>
          </Frame>
        </Form>
      )}
    </Formik>
  );
};

export default PromptForm;
